import React, { Component } from "react";
import { Link } from "react-router-dom";

class ExploreWorkBar extends Component {
  render() {
    return (
      <Link to="/#projects" className="explore-work-link">
        <div className="light-border overlap">
          <div className="bottom-bar-explore-work">
            <div className="overlay" />
            <div className="container-max-width">
              <div className="bottom-bar-explore-work-background">
                <h2>Explore artworks</h2>
              </div>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

export default ExploreWorkBar;
